module.exports = __webpack_public_path__ + "static/media/ic_education_info.683178da.svg";